export default function IconDrop({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M12.6631 2.99023C13.4062 3.92342 14.3961 5.21227 15.3838 6.63867C16.3732 8.06758 17.3505 9.62016 18.0781 11.082C18.8176 12.5678 19.2499 13.8656 19.25 14.8135C19.25 18.9366 15.9879 22.25 12 22.25C8.0121 22.25 4.75 18.9366 4.75 14.8135C4.75014 13.8656 5.18241 12.5678 5.92188 11.082C6.64947 9.62016 7.6268 8.06758 8.61621 6.63867C9.6039 5.21227 10.5938 3.92342 11.3369 2.99023C11.5893 2.6733 11.8149 2.39922 12 2.17383C12.1851 2.39922 12.4107 2.6733 12.6631 2.99023Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
}
